import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as $ from 'jquery';
import DataTable from 'datatables.net';
import moment from 'moment';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput, DataTabel } from '../components';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';
import { generalConstants } from '../constants';

class ClientsPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 401 ;
      this.props.dispatch(generalActions.getContent(0,this.pid)); 

      this.state = {
        datatables:[],
        isLoaded :false
      }

  }

  componentWillReceiveProps(props){

    this.setState({ isLoaded: false});
    const { content, upload } = props;
    const { data, id } = content;
    const { payload } = this.state;

    if(data){
        console.log("client:", data);
        this.setState({datatables:data, isLoaded: true});
    }else{
      setTimeout(()=>this.setState({ isLoaded: true}),1000);
    }
  }

  render() {
    const tableElement = $('#table_client');
    (tableElement && tableElement.DataTable());
    
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="client" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              Clients
            </h1>
            <div className="btn-placeholder">
              <Link to={generalConstants.URL+"client"}>
                <button type="submit" className="btn btn-primary">
                  <span className="visible-xs"><i className="fa fa-plus"></i>&nbsp;</span>
                  <span className="hidden-xs">Add new client</span>
                </button>
              </Link>
            </div>
          </section>
            <section className="content">
              <table id="table_client" className="display" style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Logo</th>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.datatables.map((item, index)=>{
                      return(
                        <tr key={index}>
                           <td>{index+1}</td>
                           <td><img height="64" src={(item.logo ? item.logo.data.file : '')}/></td>
                           <td className="col-md-8">{item.name}</td>
                           <td><Link to={generalConstants.URL+"client/"+item.id}><i className="fa fa-pencil" title="Edit"></i></Link></td>
                        </tr>
                        )
                    })
                  }
                </tbody>
              </table>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedClientsPage = connect(mapStateToProps)(ClientsPage);
export { connectedClientsPage as ClientsPage };


// WEBPACK FOOTER //
// ./src/pages/ClientsPage.js